import React from 'react';
import { getPercentFromCountList } from '../../helpers/vote';
import styles from './Vote.module.css';
import { Percentage } from '../Percentage/Percentage';
import { PercentageBar } from '../PercentageBar/PercentageBar';
import { iconsSourcesSvg } from '../../helpers/icons';
import { formatPhoneNumber } from '../../helpers/titreHelper';

const Vote = ({
  variants,
  title,
  withResults,
  withCircles,
  withCircleGroup,
  advtInfo,
}) => {
  let percentList = getPercentFromCountList(
    (variants || []).map((el) => +el.count)
  );

  let phoneNumberFormat = formatPhoneNumber(advtInfo?.number, '-');

  return (
    <div>
      <div className={styles.wrapper}>
        {advtInfo.qrCode && (
          <div className={styles.left}>
            <img src={advtInfo.qrCode} alt="qrCode" />
          </div>
        )}
        <div className={styles.right}>
          {advtInfo && (
            <div className={styles.advtInfo}>
              <div className={styles.advtLabel}>{advtInfo.label}</div>
              <div className={styles.advtSocials}>
                {advtInfo.socials &&
                  advtInfo.socials.map((item) => (
                    <div key={item} className={styles.advtIcon}>
                      {iconsSourcesSvg[item]}
                    </div>
                  ))}
              </div>
              <div className={styles.advtNumber}>{phoneNumberFormat}</div>
            </div>
          )}
          <div className={styles.question}>{title}</div>
          <div className={styles.vars}>
            {variants?.map((item, i) => (
              <div key={i} className={styles.var}>
                <div className={styles.varNumber}>{i + 1}</div>
                <div className={styles.varRight}>
                  <div className={styles.varInfo}>
                    <div className={styles.varTitle}>{item.comment}</div>
                    {withResults && (
                      <Percentage id={i.toString()} value={percentList[i]} />
                    )}
                  </div>
                  <div className={styles.barWrapper}>
                    {withResults && <PercentageBar width={percentList[i]} />}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        {withCircleGroup && withCircles && (
          <>
            <span className={styles.buble1}></span>
            <span className={styles.buble2}></span>
            <span className={styles.buble3}></span>
            <span className={styles.buble4}></span>
            <span className={styles.buble5}></span>
          </>
        )}
      </div>
    </div>
  );
};

export default React.memo(Vote);
